// @flow
/* eslint-env browser */

const empty = {};


/**
 * Wrap a function to memoize it's execution result.
 * NOTE: Only first argument is being taken as a cache key.
 *
 * @export
 * @param {(...args: any[]) => any} fn
 * @param {{ cache?: Map<string, any> }} [opt=empty]
 * @returns
 */
export function memoize(fn: (...args: any[]) => any, opt: { cache?: Map<string, any> } = empty) {
    const cache = opt.cache || new Map();

    function wrapper(...args: any[]) {
        const k = args[0];
        if (cache.has(k)) {
            return cache.get(k);
        }
        const result = fn.apply(this, args);
        cache.set(k, result);
        return result;
    }

    return wrapper;
}
